module.exports = {"id":"211260","name":"Mpho Makola","rating":"72","photo":"./data/images/photos/2/211260.png","club":{"name":"Orlando Pirates","logo":"./data/images/clubs/OrlandoPirates.png"},"positions":["MOC","MG","MC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MphoMakola0.json
// module id = 3097
// module chunks = 0